export interface DiscountRateModel {
  discountRate30: Array<DiscountRateModel.DiscounRate>
  discountRate75: Array<DiscountRateModel.DiscounRate>
}

export namespace DiscountRateModel {
  // export type DiscountType = 'standard' | 'reduced' | 'negative';
  export const DiscountTypeKeys = [
    'standard',
    'reduced',
    'negative',
  ] as const;
  export type DiscountType = typeof DiscountTypeKeys[number];
  export interface DiscounRate {
    type: DiscountType;
    value: number;
  }
}

